import { vue, react } from "@js/components/components";
import { createApp } from "petite-vue";
import { h, Component, render } from 'https://unpkg.com/preact?module';
import htm from 'https://unpkg.com/htm?module';

export class VueComponent {

    static initialize()
    {
        vue.forEach((component) => {
            component.mount()
        })
    }
    constructor(name, el, component)
    {
        this.name = name
        this.el = document.querySelector(el)
        this.component = component
        this.valid = this.el !== false
        return this
    }

    mount()
    {
        if(!this.valid){ return }
        this.el.setAttribute("v-scope", `${this.name}()`)
        createApp({component}).mount()
    }

}

export class ReactComponent {

    static html
    static initialize()
    {
        ReactComponent.html = htm.bind(h);
        react.forEach((component) => {
            component.mount()
        })
    }
    constructor(name, el, component)
    {
        this.name = name
        this.el = document.querySelector(el)
        this.component = component
        this.valid = this.el !== false
        return this
    }

    mount()
    {
        if(!this.valid){ return }
        const htmlComponent = ReactComponent.html`${this.component()}`
        render(ReactComponent.html`<${htmlComponent} name="${this.name}" />`, this.name);
    }

}
